import Button from '@/features/shared/Button';
import { MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import { getPageUrl } from '@/utils/helpers';
import { BrPageContext } from '@bloomreach/react-sdk';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';
import React, { memo, useCallback, useMemo } from 'react';
import { MainContentProps } from './MainContent.interface';
import useStyles from './MainContent.style';

const PressReleaseItem = ({
  cardPublicationDate,
  publicationDate,
  cardHeading,
  heading,
  classes,
  cardLink,
  cardLinkNewWindow,
  url,
}: any) => {
  const page = React.useContext(BrPageContext);
  const cardUrl = cardLink || url;
  // TODO(David Simeon): move logic into resolveDocument resolver
  const href = page && getPageUrl({ url: cardUrl, page });

  return (
    <div className={classes.content}>
      <MuiTypography variant="caption" component="p" className={classes.date}>
        {publicationDate || cardPublicationDate}
      </MuiTypography>
      {(heading || cardHeading) && (
        <Button
          variant="link"
          link={{ href, openInNewWindow: cardLinkNewWindow }}
          endIcon={
            <span className={classes.iconWrapper}>
              <ChevronRightIcon className={classes.icon} />
            </span>
          }
          className={clsx(classes.link, 'gtm-press-center-cta', 'press-release-link')}
        >
          <MuiTypography variant="h5" component="span">
            {heading || cardHeading}
          </MuiTypography>
        </Button>
      )}
    </div>
  );
};

const MainContent = ({
  content,
  dynamicContent = [],
  contentButtons,
  theme = Theme.light,
}: Br.PropsWithContentButtons<MainContentProps>) => {
  const classes = useStyles({});
  const linkRef = React.useRef<any>(null);
  const { contentList = [], cta } = content || {};
  const dynamicList = useMemo(
    () => dynamicContent.slice(contentList?.length || 0),
    [contentList?.length, dynamicContent],
  );
  const resultList = useMemo(
    () => [...contentList, ...dynamicList].slice(0, 6),
    [contentList, dynamicList],
  );
  const fitLinkAndArrow = useCallback(({ container, links }: any) => {
    if (!links || links.length < 0) return;
    const { width: widthContainer }: any = container.getBoundingClientRect() || {};
    links.forEach((link: any) => {
      const { width: widthLink }: any = link.getBoundingClientRect() || {};
      if (parseInt(widthLink, 10) > parseInt(widthContainer, 10) + 20) {
        link.classList.add('wrapSpace');
      }
    });
  }, []);

  React.useEffect(() => {
    const linkEl = linkRef?.current;
    const links = Array.from(linkEl.querySelectorAll('.press-release-link'));
    if (linkEl) {
      fitLinkAndArrow({ container: linkEl, links });
    }
  }, [fitLinkAndArrow]);

  const rootClasses = clsx(classes.root, `${theme}-theme`);
  return (
    <div className={rootClasses} ref={linkRef}>
      {contentButtons?.content}
      {resultList.length > 0 &&
        resultList.map((item, id) => (
          // eslint-disable-next-line react/no-array-index-key
          <PressReleaseItem key={id} {...item} classes={classes} />
        ))}
      {cta && <Button link={cta} className="gtm-press-center-cta" />}
    </div>
  );
};

export default memo(MainContent);
